/* Keep each engraving fee at the quantity of its engraved ring selection. */
(function (host) {
  'use strict';
  var FEE = '52539070087510';
  function isFee(item) { return String(item.variant_id) === FEE && !!(item.properties || {}).For; }
  function group(item) {
    var properties = item.properties || {};
    if (properties._spqr_engraving_group) return 'linked:' + properties._spqr_engraving_group;
    return 'legacy:' + (isFee(item) ? properties.For : item.product_title);
  }
  function plan(cart, key, quantity) {
    var items = cart.items || [], updates = {}, totals = new Map(), fees = new Map();
    if (key != null) {
      var selected = items.find(function (item) { return item.key === key; });
      if (!selected) throw new Error('Your cart changed. Refresh it before changing this item.');
      if (!Number.isInteger(quantity) || quantity < 0) throw new Error('Enter a whole quantity of zero or more.');
      if (isFee(selected)) throw new Error('To change engraving, remove the ring and add your new selection.');
      updates[key] = quantity;
    }
    items.forEach(function (item) {
      var identity = group(item), properties = item.properties || {};
      if (isFee(item)) {
        if (!fees.has(identity)) fees.set(identity, []);
        fees.get(identity).push(item);
      } else if (properties.Engraving) {
        totals.set(identity, (totals.get(identity) || 0) + (item.key === key ? quantity : item.quantity));
      }
    });
    fees.forEach(function (lines, identity) {
      var desired = totals.get(identity) || 0;
      lines.forEach(function (item, index) {
        var qty = index === 0 ? desired : 0;
        if (item.quantity !== qty) updates[item.key] = qty;
      });
    });
    totals.forEach(function (quantity, identity) {
      if (quantity > 0 && identity.indexOf('linked:') === 0 && !fees.has(identity)) {
        throw new Error('An engraving charge is missing. Remove the engraved ring and add your selection again before checkout.');
      }
    });
    return updates;
  }
  function propertiesKey(properties) {
    // Liquid exposes properties as pairs; the Ajax API returns an object.
    if (Array.isArray(properties)) properties = Object.fromEntries(properties);
    return JSON.stringify(Object.keys(properties || {}).sort().filter(function (key) {
      return properties[key] != null && properties[key] !== '';
    }).map(function (key) { return [key, String(properties[key])]; }));
  }
  function sameSelection(item, selection) {
    var sellingPlan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    return String(item.variant_id) === String(selection.variant_id) &&
      propertiesKey(item.properties) === propertiesKey(selection.properties) &&
      String(sellingPlan && sellingPlan.id || '') === String(selection.selling_plan_id || '');
  }
  function resolveItem(cart, key, selection) {
    var exact = cart.items.find(function (item) { return item.key === key; });
    if (exact) return exact;
    if (selection) {
      var matches = cart.items.filter(function (item) { return sameSelection(item, selection); });
      if (matches.length === 1) return matches[0];
      // Discounts can split an otherwise identical selection into separate lines.
      var split = matches.filter(function (item) {
        return item.quantity === selection.quantity && item.final_price === selection.final_price;
      });
      if (split.length === 1) return split[0];
    }
    throw new Error('Your cart changed. Please try again after it refreshes.');
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {plan: plan, resolveItem: resolveItem}; return;
  }
  if (!host.theme || !host.theme.cart) return;
  var cartAPI = host.theme.cart, queue = Promise.resolve();
  var root = (host.Shopify && host.Shopify.routes && host.Shopify.routes.root) || '/';
  function selectionFor(key) {
    var row = Array.from(document.querySelectorAll('.cart__item[data-key]')).find(function (item) {
      return item.dataset.key === key;
    });
    if (!row) return null;
    return {variant_id: row.dataset.variantId, properties: JSON.parse(row.dataset.properties || '{}'),
      selling_plan_id: row.dataset.sellingPlanId, quantity: Number(row.dataset.quantity),
      final_price: Number(row.dataset.finalPrice)};
  }
  function readResponse(response) {
    return response.json().then(function (cart) {
      if (!response.ok || cart.status || !Array.isArray(cart.items)) {
        var error = new Error(cart.description || cart.message || 'Could not update your cart. Please try again.');
        error.staleKey = response.status === 400 && /no valid id or line parameter/i.test(error.message);
        throw error;
      }
      return cart;
    });
  }
  function update(updates) {
    return fetch(root + 'cart/update.js', {method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({updates: updates})}).then(readResponse);
  }

  function serialized(work) {
    var operation = queue.then(work);
    queue = operation.catch(function () {});
    return operation;
  }
  cartAPI.changeItem = function (key, quantity) {
    var selection = selectionFor(key);
    quantity = Number(quantity);
    if (!Number.isInteger(quantity) || quantity < 0) {
      return Promise.reject(new Error('Enter a whole quantity of zero or more.'));
    }
    return serialized(function () {
      function change(retry) {
        return cartAPI.getCart().then(function (cart) {
          var item = resolveItem(cart, key, selection);
          if (cart.items.some(isFee)) return update(plan(cart, item.key, quantity));
          return fetch(root + 'cart/change.js', {method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({id: item.key, quantity: quantity})}).then(readResponse);
        }).catch(function (error) {
          // Retry only an explicitly rejected stale-key request, never an uncertain write.
          if (retry && error.staleKey) return change(false);
          throw error;
        });
      }
      return change(true).then(JSON.stringify);
    });
  };
  function showError(form, error) {
    var message = form.querySelector('[data-spqr-engraving-error]');
    if (!message) {
      message = document.createElement('p'); message.dataset.spqrEngravingError = '';
      message.setAttribute('role', 'alert'); form.prepend(message);
    }
    message.textContent = error.message || 'Could not update your cart. Please try again.';
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.cart__remove a'), form = link && link.closest('form');
    if (!link || !form) return;
    var item = link.closest('[data-key]');
    if (!item) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (form.dataset.cartBusy === 'true') return;
    document.dispatchEvent(new CustomEvent('cart:quantity.cart-' + form.dataset.location, {
      detail: [item.dataset.key, 0, item.querySelector('.js-qty__wrapper')]
    }));
  }, true);
  // Repair orphan/quantity mismatches in existing carts before checkout.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('#CartPageForm, #CartDrawerForm') || form.dataset.engravingChecked === 'true') return;
    var submitter = event.submitter;
    if (submitter && submitter.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    serialized(function () {
      return cartAPI.getCart().then(function (cart) {
        var updates = plan(cart);
        if (Object.keys(updates).length) return update(updates).then(function () {
          host.location.assign(root + 'cart');
        });
        form.dataset.engravingChecked = 'true';
        try { form.requestSubmit(submitter || undefined); }
        finally { delete form.dataset.engravingChecked; }
      });
    }).catch(function (error) { showError(form, error); });
  }, true);
})(typeof window !== 'undefined' ? window : globalThis);
